<template>
  <div
    v-if="!loading"
    class="sticky w-full"
    style="top: 3.5rem"
  >
    <div
      id="tocInner"
      class="flex w-full flex-col"
    >
      <div
        class="absolute bottom-2 left-0 z-0 rounded-full bg-light-gray"
        style="width: 2px; top: 6px"
      >
        <div
          id="activeBar"
          class="absolute z-20 rounded-full bg-dark-gray transition duration-500 ease-out"
          style="width: 2px; height: 12px"
        />
      </div>
      <a
        v-for="(item, index) in tocLocal"
        :id="'toc-' + item.pageId"
        :key="index"
        :ref="item.pageId"
        :data-value="item.pageId"
        :data-index="index"
        class="floating-nav-item group relative z-10 flex h-6 cursor-pointer items-center transition duration-500 ease-out"
        :class="{ active: activeSection == item.pageId }"
        @click="navChange($event)"
      >
        <p
          class="nav-item-text ml-2 inline-flex text-xs font-medium leading-tight text-body-color group-hover:text-dark-gray"
        >
          {{ item.name }}
        </p>
      </a>
    </div>
  </div>
  <div
    v-else
    class="loading-gradient relative mt-6 w-full rounded-md pb-6 pt-3"
  >
    <div
      id="tocInner"
      class="flex w-full flex-col gap-2 px-3"
    >
      <div
        v-for="(s, index) in tableOfContents"
        :key="'loading-toc-' + index"
        class="loading-dark h-4 w-full rounded-md"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableOfContents',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    showInsights: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSection: 'assessment',
      activeSectionIndex: 0,
      scrolling: false,
      switch: false,
      tableOfContents: [
        {
          name: 'Assessment',
          pageId: 'assessment',
        },
        {
          name: 'Insights',
          pageId: 'insights',
        },
        {
          name: 'Endorsements',
          pageId: 'endorsements',
        },
        {
          name: 'Secure Communications',
          pageId: 'secure-interactions',
        },
        {
          name: 'Authority',
          pageId: 'authority',
        },
      ],
    };
  },
  computed: {
    tocLength() {
      return this.tableOfContents.length;
    },
    tocHeight() {
      var toc = document.getElementById('tocInner');
      return toc.clientHeight;
    },
    tocLocal() {
      if (this.showInsights) {
        return this.tableOfContents;
      } else {
        return this.tableOfContents.filter(
          (item) => item.pageId !== 'insights'
        );
      }
    },
  },
  watch: {
    activeSectionIndex: function (newValue) {
      var activeBar = document.getElementById('activeBar');
      var newTop = newValue * 1.5;
      activeBar.style.transform = 'translateY(' + newTop + 'em)';
    },
  },
  mounted() {
    this.navItemsPreventDefault();
    this.scrollListen();
  },
  beforeUnmount: function () {
    window.onscroll = null;
  },
  methods: {
    navChange: function (event) {
      event.preventDefault;
      var self = this;
      self.scrolling = true;
      this.activeSection = event.currentTarget.getAttribute('data-value');
      this.activeSectionIndex = event.currentTarget.getAttribute('data-index');
      this.scrollToSection(this.activeSection);
    },
    scrollToSection: function (value) {
      var self = this;
      var element = document.getElementById(value);
      if (!element) {
        return;
      }
      var elTop = element.offsetTop - 10;
      this.scrollTo(elTop, function () {
        self.scrolling = false;
      });
    },
    navItemsPreventDefault: function () {
      var navItems = document.querySelectorAll('.floating-nav-item');
      navItems.forEach(function (elem) {
        elem.addEventListener('click', function (event) {
          event.preventDefault();
        });
      });
    },
    scrollListen: function () {
      var self = this;
      var section = document.querySelectorAll('.toc-section');
      var sections = {};
      var i = 0;

      Array.prototype.forEach.call(section, function (e) {
        sections[e.id] = e.offsetTop;
      });

      window.onscroll = function () {
        if (self.loading == false && self.scrolling == false) {
          var scrollPosition =
            document.documentElement.scrollTop || document.body.scrollTop;
          scrollPosition = scrollPosition + 10;
          for (i in sections) {
            if (sections[i] <= scrollPosition) {
              var newActive = document.getElementById('toc-' + i);
              if (newActive) {
                self.activeSection = newActive.getAttribute('data-value');
                self.activeSectionIndex = newActive.getAttribute('data-index');
              }
            }
          }
        }
      };
    },
    scrollTo: function (offset, callback) {
      const fixedOffset = offset.toFixed();
      const onScroll = function () {
        if (window.pageYOffset.toFixed() === fixedOffset) {
          window.removeEventListener('scroll', onScroll);
          callback();
        }
      };

      window.addEventListener('scroll', onScroll);
      onScroll();
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    },
  },
};
</script>
<style scoped>
.floating-nav-item:not(.active) .nav-line-dark {
  opacity: 0;
}

.floating-nav-item.active .nav-line-dark {
  opacity: 1;
}

.floating-nav-item.active .nav-item-text {
  color: #313545;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
}

.floating-nav-item:not(.active):hover .nav-line-dark {
  opacity: 1;
}
</style>
